import { doc, DocumentReference, serverTimestamp, updateDoc } from 'firebase/firestore'
import medicalReimbursementServiceConfigs from './configs'
import { db } from '../../firebase/firebase'
import { MedicalReimbursementRaw } from '../../database/tables'
import { ApprovalStatus } from '../../database/enums/ApprovalStatus.enum'

export type SetApprovalMedicalReimbursementByIdParams = {
  id: string
  approvalStatus: ApprovalStatus
  approvalBy: string | null
}

export default async function setApprovalMedicalReimbursementById(
  params: SetApprovalMedicalReimbursementByIdParams,
): Promise<void> {
  return new Promise(async (resolve, reject) => {
    try {
      const docRef = doc(
        db,
        medicalReimbursementServiceConfigs.collectionName,
        params.id,
      ) as DocumentReference<MedicalReimbursementRaw>

      await updateDoc(docRef, {
        approvalStatus: params.approvalStatus,
        approvalBy: params.approvalBy,
        approvalUpdatedAt: serverTimestamp(),
      })

      return resolve()
    } catch (e) {
      return reject(e)
    }
  })
}
